import styled from 'styled-components';

export const InformativeBannerWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px;
  margin-bottom: 15px;
  background: rgba(var(--clr-general-primary-rgb), 0.2);
  border-radius: 5px;
  .icon {
    font-size: 18px;
    flex-shrink: 0;
  }
  p {
    flex: 1;
  }
`;
